import { Typography, Link, Skeleton, Stack, Box } from '@mui/material';
import { IApiChangeHistoryEvent, IApiColumnInfo, IApiUserAccount, userService } from '@tap/data-providers';
import { IComponentCss } from '@tap/mui-ui';
import { EventName_BaseSlot, EventNameSlotProps } from './slots/event-name/EventName_BaseSlot';
import { EventDescription_BaseSlot, EventDescriptionSlotProps } from './slots/event-description/EventDescription_BaseSlot';
import { ChangeHistorySlotComponent } from './change-history.types';
import { JsonValueProps } from './values/JsonValue';
import { ColumnValueSlotProps } from './ChangeHistoryColumnValue';
import { SimpleColumnDiffSkeleton } from './SimpleColumnDiff';
import { dateTimeHelper } from '@tap/utils';


export type ChangeHistoryEventSlotProps = ColumnValueSlotProps & {
    eventName?: Partial<EventNameSlotProps>,
    eventDescription?: Partial<EventDescriptionSlotProps>,
    jsonValue?: Partial<JsonValueProps>,
}

type ChangeHistoryEventProps = {
    eventItem: IApiChangeHistoryEvent,
    author: IApiUserAccount | undefined,
    columnList: IApiColumnInfo[],
    slots?: ChangeHistorySlotComponent<ChangeHistoryEventSlotProps>,
    slotProps?: ChangeHistoryEventSlotProps,
}

const css: IComponentCss = {
    root: {
        padding: '16px 0px 16px 16px',
        borderBottom: ' 1px solid #e0e0e0',
    },
    header: { marginBottom: '4px' },
}

export const ChangeHistoryEventSkeleton = () => {

    return (
        <Box sx={css.root}>
            <Stack direction={'row'}
                sx={css.header}
                spacing={2}>
                <Typography variant='b1'
                    component={Link}
                >
                    <Skeleton width={100} />
                </Typography>
                <Typography variant='b1'>
                    <Skeleton width={100} />
                </Typography>
                <Typography>
                    <Skeleton width={100} />
                </Typography>
            </Stack>
            <Box>
                <SimpleColumnDiffSkeleton />
            </Box>
        </Box>
    )
};

export const ChangeHistoryEvent = ({
    eventItem,
    author,
    columnList,
    slots = {},
    slotProps = {},
}: ChangeHistoryEventProps) => {

    const components = {
        eventName: EventName_BaseSlot,
        eventDescription: EventDescription_BaseSlot,
        ...slots,
    };

    const componentProps = {
        eventName: { eventItem },
        eventDescription: { eventItem, columnList },
        ...slotProps,
    };



    return (
        <>
            <Box sx={css.root}>
                <Stack direction={'row'}
                    sx={css.header}
                    spacing={2}>
                    <Typography variant='b1' component={Link}>
                        {author ? userService.getUserFIO(author) : 'Система'}
                    </Typography>
                    <Typography variant='b1'>
                        <components.eventName {...componentProps.eventName} />
                    </Typography>
                    <Typography color="subtitle">
                        {dateTimeHelper.format(eventItem.createdAtUtc, 'dd MMMM yyyy в HH:mm')}
                    </Typography>
                </Stack>
                <Box>
                    <components.eventDescription {...{ ...componentProps.eventDescription, slots, slotProps }} />
                </Box>
            </Box>
        </>
    )
};
